/**
 */
declare namespace PIXI {
  interface Point {
    ZERO: PIXI.Point;
    ONE: PIXI.Point;
  }
}

(PIXI as any).Point.ZERO = new PIXI.Point(0, 0);
(PIXI as any).Point.ONE = new PIXI.Point(1, 1);
